import React from "react";
import "./hero.css";

export default function Hero() {
  return (
    <div className="content">
      <div>
        <h1 className="portfolio-name">Sumit Ranjan</h1>
        <h3 className="portfolio-tagline">Full Stack Developer</h3>
        <button className="portfolio-btn">Resume</button>
      </div>
    </div>
  );
}
